<template>
    <b-card no-body>
        <v-table    ref="table"
                    :items-provider="provider"
                    :fields="fields"
                    name="tachograph-wrong-driver"
                    pagination="server"
                    search>
                    </v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import EmployeeOperationsApi from '@/api/employee-operations' 
export default {
    components:{
        BCard
    },
    data(){
        return{
            loading:false,
            fields:[
                { name:"Sürücü Bilgisi",key:"DriverFullName", thClass:"w-13",tdClass:'text-nowrap',sortable:true,},
                { name:"Tarih",key:"ActivityDateStr", thClass:"w-13",tdClass:'text-nowrap',sortable:true,sortKey:'ActivityDate'},
                { name:"Sürüş Zamanı",key:"DrivingTime", thClass:"w-10",sortable:true,},
                { name:"Rölanti Zamanı",key:"AvailableTime", thClass:"w-20",tdClass:'text-nowrap',sortable:true},
                { name:"Çalışılabilir Zaman",key:"WorkingTime", thClass:"w-20",tdClass:'text-nowrap',sortable:true,},
                { name:"Gece Çalışma Zamanı",key:"NightWorkingTime", thClass:"w-10",sortable:true,},
                { name:"Dinlenme Zamanı",key:"RestTime", thClass:"w-20",tdClass:'text-nowrap',sortable:true,},
                
            ]
        }
    },
    methods:{
        provider(data){
            return EmployeeOperationsApi.Tachograph.WrongData(data)
        }
    }
}
</script>

<style>

</style>